import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeftIcon, BookOpenIcon, ShieldAlertIcon, ListOrderedIcon, CheckCircleIcon, ClipboardIcon, AwardIcon, TargetIcon, PrinterIcon } from 'lucide-react';
export function ClassDetail() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const displayName = slug?.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ') || 'Class';
  return <div className="space-y-8 max-w-3xl" data-id="element-1842">
      <Link to="/student/my-classes" className="inline-flex items-center gap-1.5 text-sm text-purple-700 hover:text-purple-900 transition-colors" data-id="element-1843">
        <ArrowLeftIcon className="h-4 w-4" data-id="element-1844" />
        Back to My Classes
      </Link>

      {/* Course Header Banner */}
      <div className="rounded-xl px-6 py-5 text-white" style={{
      backgroundColor: '#4A2D8F'
    }} data-id="element-1845">
        <div className="flex items-center gap-2 mb-1" data-id="element-1846">
          <BookOpenIcon className="h-5 w-5 text-yellow-300" data-id="element-1847" />
          <span className="text-purple-200 text-xs font-semibold uppercase tracking-wider" data-id="element-1848">
            On-Demand Class
          </span>
        </div>
        <h1 className="text-2xl font-extrabold tracking-tight" data-id="element-1849">
          {displayName}
        </h1>
      </div>

      {/* Course Description Card */}
      <div className="rounded-xl overflow-hidden border border-slate-200 shadow-sm" data-id="element-1850">
        <div className="px-4 py-3 flex items-center gap-2" style={{
        backgroundColor: '#4A2D8F'
      }} data-id="element-1851">
          <BookOpenIcon className="h-4 w-4 text-yellow-300 flex-shrink-0" data-id="element-1852" />
          <p className="text-white text-xs font-bold" data-id="element-1853">About This Course</p>
        </div>
        <div className="bg-white px-5 py-4" data-id="element-1854">
          <p className="text-sm text-slate-700 leading-relaxed" data-id="element-1855">
            This class will review the way real estate agency representation is
            provided in Arizona, how licensees are obligated to disclose their
            agency to the clients, and the various means of representing
            clients. Dual agency, exclusive agency, implied agency and
            facilitation will be reviewed.
          </p>
        </div>
      </div>

      {/* Identity Verification Warning */}
      <div className="flex items-start gap-3 rounded-xl border-2 border-amber-400 bg-amber-50 px-5 py-4" data-id="element-1856">
        <ShieldAlertIcon className="h-5 w-5 text-amber-500 flex-shrink-0 mt-0.5" data-id="element-1857" />
        <div data-id="element-1858">
          <p className="text-sm font-extrabold text-amber-800 uppercase tracking-wide mb-1" data-id="element-1859">
            Identity Verification Required
          </p>
          <p className="text-sm text-amber-900 leading-relaxed" data-id="element-1860">
            The Arizona Department of Real Estate requires that we confirm your
            identity and that you are the person taking the classes.
            Impersonating a real estate licensee is a felony in the State of
            Arizona and will be subject to a real estate forfeiture for either
            or both parties. If you are NOT the person named in the
            registration, we strongly recommend that you log out and not
            continue. We reserve the right to use reasonable means to verify
            your identity.
          </p>
        </div>
      </div>

      {/* Course Requirements */}
      <div data-id="element-1861">
        <div className="flex items-center gap-2 mb-4" data-id="element-1862">
          <ListOrderedIcon className="h-5 w-5" style={{
          color: '#4A2D8F'
        }} data-id="element-1863" />
          <h2 className="text-lg font-extrabold" style={{
          color: '#4A2D8F'
        }} data-id="element-1864">
            Course Details
          </h2>
        </div>

        <div className="space-y-3" data-id="element-1865">
          <div className="flex gap-4 bg-white rounded-xl border border-slate-200 px-4 py-4 shadow-sm" data-id="element-1866">
            <div className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-extrabold flex items-center justify-center" style={{
            backgroundColor: '#4A2D8F'
          }} data-id="element-1867">
              <ClipboardIcon className="h-4 w-4" data-id="element-1868" />
            </div>
            <div className="text-sm text-slate-700" data-id="element-1869">
              <span className="font-bold text-slate-900" data-id="element-1870">5 sections</span> to
              complete in this course
            </div>
          </div>

          <div className="flex gap-4 bg-white rounded-xl border border-slate-200 px-4 py-4 shadow-sm" data-id="element-1871">
            <div className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-extrabold flex items-center justify-center" style={{
            backgroundColor: '#4A2D8F'
          }} data-id="element-1872">
              <BookOpenIcon className="h-4 w-4" data-id="element-1873" />
            </div>
            <div className="text-sm text-slate-700" data-id="element-1874">
              <span className="font-bold text-slate-900" data-id="element-1875">Take NOTES:</span> You
              can print pages or copy & paste for your notes
            </div>
          </div>

          <div className="flex gap-4 bg-white rounded-xl border border-slate-200 px-4 py-4 shadow-sm" data-id="element-1876">
            <div className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-extrabold flex items-center justify-center" style={{
            backgroundColor: '#4A2D8F'
          }} data-id="element-1877">
              <CheckCircleIcon className="h-4 w-4" data-id="element-1878" />
            </div>
            <div className="text-sm text-slate-700" data-id="element-1879">
              <span className="font-bold text-slate-900" data-id="element-1880">Review anytime.</span>{' '}
              You can review the material at any time throughout the course
            </div>
          </div>

          <div className="flex gap-4 bg-white rounded-xl border border-slate-200 px-4 py-4 shadow-sm" data-id="element-1881">
            <div className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-extrabold flex items-center justify-center" style={{
            backgroundColor: '#E8A020'
          }} data-id="element-1882">
              <TargetIcon className="h-4 w-4" data-id="element-1883" />
            </div>
            <div className="text-sm text-slate-700" data-id="element-1884">
              <span className="font-bold text-slate-900" data-id="element-1885">
                100% to pass each quiz
              </span>{' '}
              in order to proceed to the next section
            </div>
          </div>

          <div className="flex gap-4 bg-white rounded-xl border border-slate-200 px-4 py-4 shadow-sm" data-id="element-1886">
            <div className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-extrabold flex items-center justify-center" style={{
            backgroundColor: '#E8A020'
          }} data-id="element-1887">
              <AwardIcon className="h-4 w-4" data-id="element-1888" />
            </div>
            <div className="text-sm text-slate-700" data-id="element-1889">
              <span className="font-bold text-slate-900" data-id="element-1890">
                80% to pass the final.
              </span>{' '}
              The final is a compilation of the quiz questions you have already
              answered
            </div>
          </div>

          <div className="flex gap-4 bg-white rounded-xl border border-slate-200 px-4 py-4 shadow-sm" data-id="element-1891">
            <div className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-extrabold flex items-center justify-center" style={{
            backgroundColor: '#2E7D32'
          }} data-id="element-1892">
              <PrinterIcon className="h-4 w-4" data-id="element-1893" />
            </div>
            <div className="text-sm text-slate-700" data-id="element-1894">
              <span className="font-bold text-slate-900" data-id="element-1895">
                Certificate date stamped
              </span>{' '}
              upon completion of your final. If you'd like to remain paperless,
              click "Print Certificate" to download a PDF. Save in a folder for{' '}
              <strong className="text-base" data-id="element-1896">5</strong> years (per ADRE rules)
            </div>
          </div>
        </div>
      </div>

      {/* Your Class Button */}
      <div className="flex justify-center pt-2" data-id="element-1897">
        <Link to={`/student/class/${slug}/content`} className="inline-block px-14 py-3.5 text-white text-lg font-extrabold rounded-lg transition-all hover:scale-[1.02] shadow-md text-center" style={{
        backgroundColor: '#CC0000'
      }} data-id="element-1898">
          Your Class
        </Link>
      </div>
    </div>;
}